module.exports = __webpack_public_path__ + "img/tie.692f6131.png";